export default __webpack_public_path__ + "static/profiles-2515a274f885749e2c43eb04b2585f4a.png";